import React, { useEffect } from 'react';

import { useAppSelector } from '../../../stores/redux.store';
import { isCheckUsernameRecaptchaEnabledFF } from '../../../utilities/recaptcha';
import ReCAPTCHAEnterprise from '../../../components/ReCAPTCHAEnterprise';
import ReCaptchaContainer from '../../../components/ReCaptchaContainer';
import { useLoginRecaptcha } from '../hooks/useLoginRecaptcha';
import { useLoginTooManyAttemptsRecaptchaContext } from '../contexts/LoginTooManyAttemptsRecaptchaContext';
import { usePrevious } from '../../../utilities/hooks';
import { useRegisterComponent } from '../../orchestrator';

export const LoginRecaptcha = () => {
  useRegisterComponent(LoginRecaptcha.name);

  const { recaptcha } = useLoginRecaptcha();

  const isSecondStep = useAppSelector(state => state.login?.isUsernameChecked);
  const isCaptchaRequired = useAppSelector(state => state.login?.isCaptchaRequired);

  const isCheckUsernameRecaptchaEnabled = isCheckUsernameRecaptchaEnabledFF();

  const shouldRenderCheckUsernameRecaptcha =
    isCheckUsernameRecaptchaEnabled && !isSecondStep && recaptcha.enabled && recaptcha.component;

  const { setCaptchaValue } = useLoginTooManyAttemptsRecaptchaContext();
  const shouldRenderTooManyAttemptsRecaptcha = isSecondStep && isCaptchaRequired;

  const prevIsCaptchaRequired = usePrevious(isCaptchaRequired);

  useEffect(() => {
    if (prevIsCaptchaRequired && !isCaptchaRequired) {
      setCaptchaValue(null);
    }
  }, [isCaptchaRequired, prevIsCaptchaRequired, setCaptchaValue]);

  const isCaptchaEnabledByConfig = useAppSelector(state => state.appConfig?.recaptchaEnable);
  const recaptchaEnterpriseCheckboxKeySite = useAppSelector(
    state => state.appConfig?.recaptchaEnterpriseCheckboxKeySite
  );

  return (
    <>
      {isCaptchaEnabledByConfig &&
        (shouldRenderCheckUsernameRecaptcha ? (
          <ReCaptchaContainer>{recaptcha.component}</ReCaptchaContainer>
        ) : (
          shouldRenderTooManyAttemptsRecaptcha && (
            <ReCaptchaContainer>
              <ReCAPTCHAEnterprise
                sitekey={recaptchaEnterpriseCheckboxKeySite}
                onChange={setCaptchaValue}
              />
            </ReCaptchaContainer>
          )
        ))}
    </>
  );
};
